module.exports = __webpack_public_path__ + "assets/c89fe29b3ac61b281547b3828807b252.mp3";